import StudyActionLinks from './StudyActionLinks';

export default StudyActionLinks;
